/*
 * Services Variant 6: Rounded Rectangle Cards with Background Images
 * JavaScript for animations and interactions
 * Based on Variant 4 but adapted for rectangular cards
 */

document.addEventListener('DOMContentLoaded', function() {
    
    // Initialize variant 6 animations when variant 6 section comes into view
    function initVariant6() {
        const variant6Section = document.querySelector('.services-variant-6');
        if (!variant6Section) return;

        const rectangles = variant6Section.querySelectorAll('.service-rectangle');
        
        // Intersection Observer for scroll animations
        const observerOptions = {
            threshold: 0.3,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    const rectangles = entry.target.querySelectorAll('.service-rectangle');
                    
                    // Stagger animation for each rectangle
                    rectangles.forEach(function(rectangle, index) {
                        setTimeout(function() {
                            rectangle.classList.add('animate-in');
                        }, index * 200); // 200ms delay between each rectangle
                    });
                    
                    // Unobserve after animation is triggered
                    observer.unobserve(entry.target);
                }
            });
        }, observerOptions);

        observer.observe(variant6Section);

        // Enhanced hover effects for rectangles
        rectangles.forEach(function(rectangle) {
            
            // Mouse enter effect
            rectangle.addEventListener('mouseenter', function() {
                // Pause floating animation on hover
                this.style.animationPlayState = 'paused';
                
                // Add hover glow effect
                this.style.filter = 'drop-shadow(0 0 20px rgba(254, 100, 46, 0.4))';
            });

            // Mouse leave effect  
            rectangle.addEventListener('mouseleave', function() {
                // Resume floating animation
                this.style.animationPlayState = 'running';
                
                // Remove hover glow effect
                this.style.filter = 'none';
            });

            // Enhanced button hover effects
            const button = rectangle.querySelector('.service-btn');
            if (button) {
                button.addEventListener('mouseenter', function() {
                    // Add subtle scale and glow
                    this.style.transform = 'translateY(-2px) scale(1.05)';
                    this.style.boxShadow = '0 8px 25px rgba(254, 100, 46, 0.3)';
                });

                button.addEventListener('mouseleave', function() {
                    this.style.transform = 'translateY(-2px) scale(1)';
                    this.style.boxShadow = 'none';
                });
            }

            // Icon rotation animation enhancement
            const icon = rectangle.querySelector('.service-icon');
            if (icon) {
                rectangle.addEventListener('mouseenter', function() {
                    // Add a subtle pulse effect to the icon
                    icon.style.animation = 'pulse 0.6s ease-in-out';
                });
            }
        });

        // Add custom keyframes for pulse animation
        if (!document.getElementById('variant6-pulse-style')) {
            const style = document.createElement('style');
            style.id = 'variant6-pulse-style';
            style.textContent = `
                @keyframes pulse {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.1); }
                    100% { transform: scale(1.2) rotate(360deg); }
                }
            `;
            document.head.appendChild(style);
        }
        // Parallax effect for background
        function handleScroll() {
            const scrolled = window.pageYOffset;
            const background = variant6Section.querySelector('::before');
            
            if (variant6Section.getBoundingClientRect().top < window.innerHeight && 
                variant6Section.getBoundingClientRect().bottom > 0) {
                
                variant6Section.style.transform = `translateY(${scrolled * 0.1}px)`;
            }
        }

        // Throttled scroll handler
        let ticking = false;
        function requestTick() {
            if (!ticking) {
                requestAnimationFrame(handleScroll);
                ticking = true;
                setTimeout(() => ticking = false, 16);
            }
        }

        window.addEventListener('scroll', requestTick);

        // Smooth scroll for service buttons
        const serviceButtons = variant6Section.querySelectorAll('.service-btn');
        serviceButtons.forEach(function(button) {
            button.addEventListener('click', function(e) {
                //e.preventDefault();
                
                // Add click ripple effect
                const ripple = document.createElement('span');
                ripple.style.cssText = `
                    position: absolute;
                    border-radius: 50%;
                    background: rgba(255, 255, 255, 0.6);
                    transform: scale(0);
                    animation: ripple 0.6s linear;
                    width: 20px;
                    height: 20px;
                    left: ${e.offsetX - 10}px;
                    top: ${e.offsetY - 10}px;
                `;
                
                this.appendChild(ripple);
                
                // Remove ripple after animation
                setTimeout(() => {
                    ripple.remove();
                }, 600);

                // Add ripple keyframes if not exists
                if (!document.getElementById('variant6-ripple-style')) {
                    const rippleStyle = document.createElement('style');
                    rippleStyle.id = 'variant6-ripple-style';
                    rippleStyle.textContent = `
                        @keyframes ripple {
                            to {
                                transform: scale(4);
                                opacity: 0;
                            }
                        }
                    `;
                    document.head.appendChild(rippleStyle);
                }
            });
        });

        console.log('Services Variant 6: Rounded Rectangles initialized successfully!');
    }

    // Initialize variant 6
    initVariant6();

    // Reinitialize if content is dynamically loaded
    document.addEventListener('variant6Reload', initVariant6);
});

// Utility function to trigger variant 6 animations manually
function triggerVariant6Animation() {
    const rectangles = document.querySelectorAll('.services-variant-6 .service-rectangle');
    rectangles.forEach(function(rectangle, index) {
        rectangle.classList.remove('animate-in');
        setTimeout(function() {
            rectangle.classList.add('animate-in');
        }, index * 200);
    });
}